import React from "react";
import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import getRootStore from "../../../../stores/core/root-store";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { isPositiveNumber } from "et3-type-guards";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../../helpers/et3-picker-data-helper";
import getOtherAuditorsPerformanceStore from "../../../../stores/supervisor-store/other-auditors-performance-store";

const PerformanceForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const allAdmins = getRootStore().allAdmins.get();
  const isEnabled = isPositiveNumber(
    reducerToZeroIfUndefined(
      parseInt(getOtherAuditorsPerformanceStore().adminInput.get().value, 10)
    )
  );

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("ADMIN")}
          options={allAdmins}
          value={getOtherAuditorsPerformanceStore().adminInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getOtherAuditorsPerformanceStore().setAdmin(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getOtherAuditorsPerformanceStore().fromDate}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} left={20} right={20} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getOtherAuditorsPerformanceStore().toDate}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () =>
          getOtherAuditorsPerformanceStore().getOtherAuditorsPerformanceData()
        }
        isEnabled={isEnabled}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default PerformanceForm;
